/// <reference path="../../../node_modules/@types/bootstrap/index.d.ts"/>

import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { SlickGridColumns } from "app/shared/models/slick-grid-columns";
import { SlickGridProperties } from "app/shared/models/slick-grid-properties";
import { SaveUserPropService } from "app/services/save-user-prop";
import { GetSlickGridProp } from "app/shared/models/get-slick-grid-prop";
import {MainHelper} from "../shared/models/main-helper";
import {DialogOptions} from "../shared/models/dialogOptions";
import {Observable} from "rxjs/Observable";
import {ColumnSettingsBase} from "../slick-grid/models/column-settings-base";
import {SlickGridComponent} from "../slick-grid/slick-grid.component";
import {c} from "@angular/core/src/render3";

@Injectable()
export class CommonDataService {
    constructor(router: Router, private readonly titleService: Title, public readonly translateService: TranslateService, public readonly saveUserProp: SaveUserPropService ) {
        router.events.subscribe(this.onRouterEvent);
        this.codesSplitter = ', ';
        this.dialogQueue = [];
        this.locale = localStorage['UserLocale'];
        this.helper = new MainHelper();
        this.dlgOpt = new DialogOptions();
    }

    private loginMode: boolean;
    get isLoginMode(): boolean {
        return this.loginMode;
    }

    private locale: string;
    get language(): string {
        return this.locale;
    }
    set language(value: string) {
        this.locale = value;
        localStorage['UserLocale'] = value;
    }

    isAnyInitDataLoaded: boolean;

    codesSplitter: string;

    public popupActive: boolean;

    private readonly dialogQueue: number[];

    public inClass: {[index: string]: boolean};
    private helper: MainHelper;
    public dlgOpt: DialogOptions;
    // public okTxt: string;
    // public yesTxt: string;
    // public noTxt: string;
    // public cancelTxt: string;
    // public okTitle: string;
    // public yesTitle: string;
    // public noTitle: string;
    // public cancelTitle: string;

    private dlgType: string;
    get dialogType(): string {
        return this.dlgType;
    }

    private messages: string[];
    get messageList(): string[] {
        return this.messages;
    }

    private selections: string[];
    get selectionList(): string[] {
        return this.selections;
    }

    private dlgTitle: string;
    get dialogTitle(): string {
        return this.dlgTitle;
    }

    private dlgOnOk: () => void;
    get dialogOnOk(): () => void {
        return this.dlgOnOk;
    }

    private dlgOnYes: () => void;
    get dialogOnYes(): () => void {
        return this.dlgOnYes;
    }

    private dlgOnSelection: (idx: number) => void;
    get dialogOnSelection(): (idx: number) => void {
        return this.dlgOnSelection;
    }

    private dlgOnNo: () => void;
    get dialogOnNo(): () => void {
        return this.dlgOnNo;
    }

    private dlgOnCancel: () => void;
    get dialogOnCancel(): () => void {
        return this.dlgOnCancel;
    }

    public _showLoadingImg: boolean;

    public set showLoadingImg(val: boolean){
        this._showLoadingImg = val;
    };

    public get showLoadingImg(){
        return this._showLoadingImg;
    };

    //# show dialog window with errors, if function passed by parameter, it is executed
    showErrors = (errors: string[], onOk?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Error';
            this.dlgTitle = 'ErrorModalHeader';

            this.dlgOnOk = onOk;
            this.messages = errors;

            this.showModal(() => {
                this.dlgOnOk = null;
                onHidden();
            });
        });
    }

    //# show dialog window with errors, if function passed by parameter, it is executed
    showExErrors = (classes : string[], title: string, options: DialogOptions, errors: string[], onOk?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Error';
            this.dlgTitle = title ? title : 'ErrorModalHeader';
            this.inClass = this.helper.generateNgClass(classes);
            this.updateBtn(options);

            this.dlgOnOk = onOk;
            this.messages = errors;

            this.showModal(() => {
                this.dlgOnOk = null;
                this.dlgOpt.init();
                this.inClass = {};
                onHidden();
            });
        });
    }

    //# show dialog window with question, if function passed by parameter, it is executed
    public readonly showQuestions = (questions: string[], onYes: () => void, onNo?: () => void, onCancel?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Question';
            this.dlgTitle = 'QuestionModalHeader';

            this.dlgOnYes = onYes;
            this.dlgOnNo = onNo || (() => {});
            this.dlgOnCancel = onCancel;
            this.messages = questions;

            this.showModal(() => {
                this.dlgOnYes = null;
                this.dlgOnNo = null;
                this.dlgOnCancel = null;
                onHidden();
            });
        });
    }

    //# show dialog window with question, if function passed by parameter, it is executed, with extended properties
    public readonly showExQuestions = (classes : string[], title: string, options: DialogOptions, questions: string[], onYes: () => void, onNo?: () => void, onCancel?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Question';
            this.dlgTitle = title ? title : 'QuestionModalHeader';
            this.inClass = this.helper.generateNgClass(classes);
            this.updateBtn(options);

            this.dlgOnYes = onYes;
            this.dlgOnNo = onNo || (() => {});
            this.dlgOnCancel = onCancel;
            this.messages = questions;

            this.showModal(() => {
                this.dlgOnYes = null;
                this.dlgOnNo = null;
                this.dlgOnCancel = null;
                this.dlgOpt.init();
                this.inClass = {};
                onHidden();
            });
        });
    }

    //# show dialog window with radio select,
    public readonly showRadioSelection = (selections: string[], onSelect: (idx: number) => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Selection';
            this.dlgTitle = 'SelectionModalHeader';

            this.dlgOnSelection = onSelect;
            this.selections = selections;

            this.showModal(() => {
                this.dlgOnSelection = null;
                onHidden();
            });
        });
    }

    //# show dialog window with radio select, extented
    public readonly showExRadioSelection = (classes : string[], title: string, options: DialogOptions, selections: string[], onSelect: (idx: number) => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Selection';
            this.dlgTitle = title ? title : 'SelectionModalHeader';
            this.inClass = this.helper.generateNgClass(classes);

            this.dlgOnSelection = onSelect;
            this.selections = selections;

            this.showModal(() => {
                this.dlgOnSelection = null;
                this.inClass = {};
                onHidden();
            });
        });
    }

    //# show dialog window with simple information, if function passed by parameter, it is executed
    public readonly showInfo = (messages: string[], onOk?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Info';
            this.dlgTitle = 'InfoModalHeader';

            this.dlgOnOk = onOk;
            this.messages = messages;

            this.showModal(() => {
                this.dlgOnOk = null;
                onHidden();
            });
        });
    }

    //# show dialog window with simple information, if function passed by parameter, it is executed
    public readonly showExInfo = (classes : string[], title: string, options: DialogOptions,  messages: string[], onOk?: () => void): void => {
        this.enqueueDialog((onHidden: () => void) => {
            this.dlgType = 'Info';
            this.dlgTitle = title ? title : 'InfoModalHeader';
            this.inClass = this.helper.generateNgClass(classes);
            this.updateBtn(options);

            this.dlgOnOk = onOk;
            this.messages = messages;

            this.showModal(() => {
                this.dlgOnOk = null;
                this.dlgOpt.init();
                this.inClass = {};
                onHidden();
            });
        });
    }

    //# show modal dialog
    private showModal = (onHidden?: () => void): void => {
        $('#app-dialog').on('shown.bs.modal', (e) => {
            $(e.target).off('shown.bs.modal').find('.modal-footer button').last().focus();
            $('.modal-backdrop').addClass('up-z-index');
            $(e.target).addClass('up-z-index-2');
            this.popupActive = true;
        }).on('hidden.bs.modal', (e) => {
            this.messages = null;
            this.selections = null;
            this.popupActive = false;
            // console.log(e.target)
            $(e.target).off('hidden.bs.modal');
            $('.modal-backdrop').removeClass('up-z-index');
            $(e.target).removeClass('up-z-index-2');
            if (onHidden){
                onHidden();
            }

            }).modal({ backdrop: 'static', keyboard: false });
    }

    //# show current dialog, from list of dialogs
    private enqueueDialog(command: (onHidden: () => void) => void) {
        const timeStamp = Date.now();
        this.dialogQueue.push(timeStamp);
        const timer = setInterval(() => {
            if (this.dialogQueue.length === 0) {
                clearInterval(timer);
                return;
            }
            if (this.dialogQueue[0] !== timeStamp)
                return;

            clearInterval(timer);

            command(() => setTimeout(() => this.dialogQueue.splice(0, 1), 100));
        },0);
    }



    private onRouterEvent = (event: Event): void => {
        if (event instanceof NavigationEnd)
            this.loginMode = event.url.startsWith('/login');
    };

    //# set title to page
    setPageTitle = (key: string): void => {
        this.translateService.get(key).subscribe(t => this.titleService.setTitle(t));
    };


    private updateBtn = (options: DialogOptions): void => {
        this.dlgOpt.consumeOptions(options);
    }

    //# save slickgrig properties
    public saveSlickGridProp = (grid: SlickGridComponent, moduleName: string, tableName: string, slickGridProp: SlickGridColumns[], tableIndex?: number) => {

        if (!tableIndex) tableIndex = 0;

        let data = grid.getColumns().map(c => new SlickGridProperties(c.id, c.width, !!c.disabled)),
            toAdd = [];

        grid.getAllColumns().forEach(ac => {
            if (!data.some(c => c.id === ac.id)){
                toAdd.push(new SlickGridProperties(ac.id, ac.width, !!ac.disabled));
            }
        })
        data = data.concat(toAdd);
        //data = data.map( r => new SlickGridProperties(r.id, r.width, !!r.disabled));
        let table = [];
        table.push(new SlickGridColumns(tableName, data, tableIndex));

        let found: boolean;

        slickGridProp.forEach(item => {
           if (item.tableName === table[0].tableName) {
                found = true;
                item.data[tableIndex] = table[0].data[tableIndex];
           }
        });

        if (!found) slickGridProp.push(table[0]);
        let json = JSON.stringify({ moduleName: moduleName, table: table });
        this.saveUserProp.saveSlickGridProperties(json).subscribe();
    };

    //# set slickgrid properties to grid columns
    public setSlickGridProp = (getData: GetSlickGridProp[], slickGridProp: SlickGridColumns[]): void => {
        getData.forEach(outerItem => {
            try{
                let tableName = outerItem.tableName,
                    tableIndex = outerItem.tableIndex,
                    columns = outerItem.columns,
                    props = slickGridProp.filter( r => r.tableName === tableName);

                if (props.length === 0) return;

                let propsCurrent = props[0].data[tableIndex];

                if (!propsCurrent || propsCurrent.length === 0) return;

                propsCurrent.forEach((item, i) => {
                    let count = i;

                    while (count < columns.length) {
                        count ++;

                        if (!item.id) continue;
                        if (item.id !== columns[i].id) {
                            let removed = columns.splice(i, 1);
                            columns.push(removed[0]);
                        } else {
                            columns[i].width = item.width;
                            columns[i].disabled = item.disabled;
                            return;
                        }
                    }
                });
            } catch (e){

            }

        });
    };
}



// WEBPACK FOOTER //
// ./src/app/services/common-data.service.ts